var map = {
	"./InfraredDetection.png": "0673",
	"./Leak.png": "722d",
	"./Noise.png": "96bc",
	"./Smoke.png": "3988",
	"./TempHumidity.png": "1a86",
	"./exception.png": "99a9",
	"./normal.png": "cace",
	"./电表.png": "5854",
	"./空调.png": "d58d",
	"./给排水.png": "8877"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4382";